import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const Badge = props => {
  return (
    <SvgIcon {...props} width="35.391" height="45.414" viewBox="0 0 35.391 45.414">
      <g transform="translate(0.254 0.259)">
        <circle
          fill="#fcd469"
          stroke="#4d4d4d"
          strokeWidth={0.5}
          cx="7.161"
          cy="7.161"
          r="7.161"
          transform="translate(10.279 10.142)"
        />
        <path
          fill="#ff7141"
          stroke="#4d4d4d"
          strokeWidth={0.5}
          d="M48.235,16.652a2.878,2.878,0,0,0-.589-4.087l-1.22-.885A2.878,2.878,0,0,1,45.249,9.1l.129-1.5a2.878,2.878,0,0,0-2.7-3.136L41.168,4.38a2.878,2.878,0,0,1-2.383-1.533l-.7-1.335A2.878,2.878,0,0,0,34.119.362l-1.31.742a2.878,2.878,0,0,1-2.836,0L28.662.362A2.878,2.878,0,0,0,24.7,1.526L24,2.861a2.878,2.878,0,0,1-2.383,1.533l-1.505.084a2.878,2.878,0,0,0-2.7,3.136l.129,1.5a2.878,2.878,0,0,1-1.178,2.579l-1.22.885a2.878,2.878,0,0,0-.589,4.087l.92,1.192a2.878,2.878,0,0,1,.4,2.805l-.547,1.394a2.878,2.878,0,0,0,1.714,3.756l1.418.505a2.878,2.878,0,0,1,1.857,2.143l.272,1.324-3.62,11.767,5.743-1.8,3.575,4.837,3.265-10.673a2.878,2.878,0,0,0,3.509.129L36.5,44.591l3.575-4.837,5.743,1.8L42.106,30.179c.024-.08.045-.157.063-.24l.3-1.477a2.878,2.878,0,0,1,1.857-2.143l1.418-.505a2.878,2.878,0,0,0,1.714-3.756l-.547-1.394a2.878,2.878,0,0,1,.4-2.805Zm-26.793.634a9.948,9.948,0,1,1,9.948,9.948,9.948,9.948,0,0,1-9.948-9.948Z"
          transform="translate(-13.951 0.016)"
        />
      </g>
    </SvgIcon>
  );
};

export default Badge;
